import React from 'react';
import { PLATFORMS } from '~/constants';

import { WlWindow } from '../../typings/globals/cordova';

declare const window: WlWindow;

const IncludeOnPlatforms =
  <P extends object>(includedPlatforms: PLATFORMS[]) =>
  (WrappedComponent: React.ComponentType<P>) => {
    const platformName = PLATFORM as PLATFORMS;
    return (props: P) => {
      const isServer =
        window.isPreRender && includedPlatforms.includes(PLATFORMS.SERVER);
      if (isServer || includedPlatforms.includes(platformName)) {
        return <WrappedComponent {...props} />;
      }
      return null;
    };
  };

export default IncludeOnPlatforms;
